// extracted by mini-css-extract-plugin
export default {"cls1":"FilterForm-Footer_cls1__F90q6","cls2":"FilterForm-Footer_cls2__rw248 FilterForm-Footer_cls1__F90q6"};